<table>
    <tbody>
        @for (taxableValue of taxableValues; track taxableValue; let i = $index) {
            <tr>
                <td><strong class="me-2">Taxable{{(i > 0) ? (i + 1) : ''}}{{ taxableValue.description?.trim() ? ' (' + taxableValue.description.trim() + ')' : '' }}:</strong></td>
                <td class="text-right">{{ taxableValue.fairMarketValue | number: '1.0-0' }}</td>
            </tr>
        }
    </tbody>
</table>
